import { useState } from 'react';
import { Button } from '@mui/material';

import { StyledTextField } from '@labradorsports/components';

interface Props {
    onCancel: AnyFunction;
    onSubmit: (text: string) => void;
}

const AddCommentForm: FC<Props> = ({ onCancel, onSubmit }) => {
    const [text, setText] = useState('');

    const onTextChange = (evt) => {
        setText(evt.target.value);
    };

    const postClick = () => {
        onSubmit(text);
    };

    return (
        <div className="add-comment-form">
            <div className="comment-details p-2">
                <h4>Add Comment</h4>
                <StyledTextField label="Comment" value={text} onChange={onTextChange} fullWidth multiline />
            </div>
            <div className="buttons-bar">
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={postClick}>Post</Button>
            </div>
        </div>
    );
};

export default AddCommentForm;
